import { render } from "./SoundMeasure.vue?vue&type=template&id=bdccfc78"
import script from "./SoundMeasure.vue?vue&type=script&lang=js"
export * from "./SoundMeasure.vue?vue&type=script&lang=js"
script.render = render

export default script